var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1538_28146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5156 0.130859C9.91805 0.130859 0.515625 9.53328 0.515625 21.1309C0.515625 32.7284 9.91805 42.1309 21.5156 42.1309C33.1132 42.1309 42.5156 32.7284 42.5156 21.1309C42.5156 9.53328 33.1132 0.130859 21.5156 0.130859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8131 19.2302L32.8029 8.78027H30.6726L22.8667 17.8538L16.6322 8.78027H9.44141L18.8692 22.5011L9.44141 33.4595H11.5718L19.8151 23.8775L26.3992 33.4595H33.59L23.8125 19.2302H23.8131ZM12.3394 10.384H15.6116L30.6736 31.9287H27.4014L12.3394 10.384Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1538_28146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.515625 0.130859)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.49b1e3703db39c3cfd26f8424a7331ef.svg";
export { ForwardRef as ReactComponent };